import cn from 'classnames';
import React from 'react';
import styles from './Title.module.css';

interface TitleProps {
  children: string;
  className?: string;
  alignSurvey?: 'left' | 'center';
}

export const Title: React.FC<TitleProps> = ({ children, className, alignSurvey = 'left' }) => {
  const alignByCenter = alignSurvey === 'center';

  return <h1 className={cn(styles.title, className, { [c(styles.centerTitle)]: alignByCenter })}>{children}</h1>;
};
